import { Box, makeStyles, Typography } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setOpenNotify } from "src/redux/account-slice";
import { capitalizeFirstLetter, formatTokenId, timeHasPassed } from "src/utils";
import knightAssetsMapping, { rarities } from "src/utils/old-version-knight";

const useStyles = makeStyles(() => ({
  wp: {
    height: "86px",
    borderBottom: "1px solid rgba(255,255,255,0.25)",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  knightWp: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  knightImg: {
    width: "70px",
    height: "70px",
    objectFit: "contain",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    margin: "10px 8px",
    flexGrow: 1,
  },
  timestamp: {
    margin: "1px 0",
    fontSize: "12px",
    color: "#4d83b9",
  },
  successWp: {
    color: "#67bf38",
    fontSize: "12px",
    "& .MuiSvgIcon-root": {
      verticalAlign: "-2px",
      fontSize: "12px",
    },
  },
  lastRecord: {
    border: "none",
  },
}));

const listColor = {
  limited: "#433214",
};

export default function TreasureMapNotify({ item, isLastRecord }) {
  const cls = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const renderTreasureMapName = (treasureMapName) => {
    return (
      <span style={{ color: listColor?.[treasureMapName] || "violet" }}> {capitalizeFirstLetter(treasureMapName)}</span>
    );
  };
  const renderTimestamp = (timestamp) => {
    return timeHasPassed(timestamp);
  };
  const renderKnight = (rarity) => {
    const textRarity = rarities[rarity];
    return knightAssetsMapping.genesis[textRarity].full;
  };
  return (
    <Box
      onClick={() => {
        history.push("/treasure-map/limited");
        dispatch(setOpenNotify(false));
      }}
      className={clsx(cls.wp, { [cls.lastRecord]: isLastRecord })}
      key={item.collectionId}
    >
      <Box m={1} className={cls.knight}>
        <img src={renderKnight(item.rarity)} className={cls.knightImg} />
      </Box>
      <Box className={cls.info}>
        <Box alignItems="center" justifyContent="space-between" display="flex">
          <Typography style={{ color: "#888e98", fontSize: "14px", fontWeight: 600, margin: "1px 0" }}>
            ID: <span style={{ color: "white" }}>#C{formatTokenId(item.collectionId)}</span>
          </Typography>
          <Typography className={cls.successWp}>
            <FiberManualRecord />
            Success
          </Typography>
        </Box>
        <Typography style={{ color: "#888e98", fontSize: "14px", fontWeight: 600, margin: "1px 0" }}>
          Treasure Map: {renderTreasureMapName(item.map)}
        </Typography>
        <Typography className={cls.timestamp}>Time: {renderTimestamp(item.finishTime)}</Typography>
      </Box>
    </Box>
  );
}
